import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

var ChipType = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};
var ChipAppearance = {
  PRIMARY: "primary",
  BLACK: "black"
};
var ChipSize = {
  SM: "sm",
  MD: "md",
  XS: "xs"
};

var _excluded = ["label", "type", "size", "className", "mRef", "appearance"];

var Chip = _ref => {
  var _clsAppearance$appear;

  var {
    label = "",
    type = ChipType.ACTIVE,
    size = ChipSize.SM,
    className = "",
    mRef = null,
    appearance = ChipAppearance.PRIMARY
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var clsBackground = {
    [ChipType.ACTIVE]: "text-neutral-800 bg-white border active:shadow-none dark:text-neutral-200",
    [ChipType.INACTIVE]: "text-neutral-600 hover:text-neutral-800 active:hover:text-neutral-800 bg-transparent border border-neutral-200 hover:bg-neutral-100 active:bg-neutral-200  dark:text-neutral-700"
  };
  var clsFontSize = {
    [ChipSize.XS]: "text-xs",
    [ChipSize.SM]: "text-sm",
    [ChipSize.MD]: "text-base"
  };
  var clsPadding = {
    [ChipSize.XS]: "px-3 py-2 h-9",
    [ChipSize.SM]: "px-4 py-2.5",
    [ChipSize.MD]: "px-5 py-3"
  };
  var clsAppearance = {
    [ChipAppearance.PRIMARY]: {
      [ChipType.ACTIVE]: "border-accent-700 shadow-lg"
    },
    [ChipAppearance.BLACK]: {
      [ChipType.ACTIVE]: "border-neutral-800 border-2"
    }
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "Chip",
    className: clsx("inline-block cursor-pointer whitespace-nowrap rounded-full dark:bg-midnight", clsBackground[type], clsFontSize[size], clsPadding[size], (_clsAppearance$appear = clsAppearance[appearance]) === null || _clsAppearance$appear === void 0 ? void 0 : _clsAppearance$appear[type], className),
    ref: mRef
  }, rest), label);
};

Chip.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(Object.values(ChipType)),
  size: PropTypes.oneOf(Object.values(ChipSize)),
  appearance: PropTypes.oneOf(Object.values(ChipAppearance)),
  className: PropTypes.string,
  mRef: PropTypes.shape({
    current: PropTypes.any
  })
};

export { ChipSize as C, ChipAppearance as a, Chip as b };
//# sourceMappingURL=Chip-e2a6d1f0.js.map
